<!--订单管理-->
<template>
  <div class="order-container">
    <headerIndex/>
    <div class="order-header">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" background-color="#FFFFFF" @select="handleSelect2"
               text-color="#333333" active-text-color="#FE273B" router active-background-color="#FE273B">
        <el-menu-item :index="navigation.href" v-for="navigation of navigationBar">{{ navigation.name }}</el-menu-item>
      </el-menu>
    </div>
    <div class="left-header" :style="'min-height:'+min_heights+'px;'">
      <el-container>
        <el-aside width="180px" style="background: #ffffff;">
          <el-menu :default-active="activeIndex2" class="el-menu-vertical-demo" @select="handleSelect"
                   background-color="#FFFFFF" active-text-color="#FE273B">
            <el-menu-item :index="vertical.href" v-for="vertical of navigationBar2">{{ vertical.name }}</el-menu-item>
          </el-menu>
        </el-aside>
        <el-main>
          <all-order v-if="activeIndex2=='/orderManagement/AllOrder'"/>
          <to-paid v-if="activeIndex2=='/orderManagement/toPaid'"/>
          <in-service v-if="activeIndex2=='/orderManagement/inService'"/>
          <to-evaluated v-if="activeIndex2=='/orderManagement/toEvaluated'"/>
          <completed v-if="activeIndex2=='/orderManagement/completed'"/>
          <after-sales v-if="activeIndex2=='/orderManagement/afterSales'"/>
        </el-main>
      </el-container>
    </div>
    <Hang/>
    <Home_footer/>
  </div>
</template>
<script>
import headerIndex from "@/components/header/headerIndex";
import AllOrder from "@/views/orderManagement/AllOrder";
import ToPaid from "@/views/orderManagement/toPaid";
import Hang from "@/components/Hang/Hang";
import Home_footer from "@/components/footer/home_footer";
import InService from "@/views/orderManagement/inService";
import ToEvaluated from "@/views/orderManagement/toEvaluated";
import Completed from "@/views/orderManagement/completed";
import AfterSales from "@/views/orderManagement/afterSales";
export default {
  name: "index",
  components: {AfterSales, Completed, ToEvaluated, InService, Home_footer, Hang, ToPaid, AllOrder, headerIndex},
  data() {
    return {
      activeIndex: '/orderManagement/index',
      min_height: document.documentElement.clientHeight,
      min_heights: document.documentElement.clientHeight-346,
      navigationBar: [
        {name: '订单管理', index: 1, href: '/orderManagement/index'},
        {name: '个人中心', index: 2, href: '/personal/index'},
        {name: '账号管理', index: 3, href: '/accountManagement/index'},
        // {name: '在线客服', index: 4, href: ''}
      ],
      activeIndex2: '/orderManagement/AllOrder',
      navigationBar2: [
        {name: '全部订单', index: 1, href: '/orderManagement/AllOrder'},
        {name: '待付款', index: 2, href: '/orderManagement/toPaid'},
        {name: '服务中', index: 3, href: '/orderManagement/inService'},
        {name: '待评价', index: 4, href: '/orderManagement/toEvaluated'},
        {name: '已完成', index: 5, href: '/orderManagement/completed'},
        {name: '售后退款', index: 6, href: '/orderManagement/afterSales'},
      ],
    }
  },
  methods: {
    handleSelect(key) {
      this.activeIndex2 = key;
      localStorage.setItem('orderIndex',key);
    },
    handleSelect2(key){
      if (key!=''){}else{
        let routeData = this.$router.resolve({
          name: "onlineService",
          path: '/onlineService/index'
        });
        window.open(routeData.href, '_blank')
      }
    }
  },
  mounted() {
    this.activeIndex2=localStorage.getItem('orderIndex') ? localStorage.getItem('orderIndex'): '/orderManagement/AllOrder';
  }
}
</script>
<style scoped>
.order-container >>> .order-header .el-menu--horizontal > .el-menu-item {
  float: left;
  height: 50px;
  line-height: 50px;
  margin: 0px 50px 0px 0px;
  padding: 0 0px;
  border-bottom: 2px solid transparent;
  color: #333333;
  font-size: 16px;
}
.order-container >>> .left-header .el-menu-item {
  height: auto;
  line-height: normal;
  font-size: 14px;
  color: #333333;
  padding: 20px 20px;
  border-bottom: 1px solid #F1F1F1;
}
.order-container >>> .left-header .el-card__body, .el-main {
  padding: 0px 0px 0px 10px;
}
.order-container >>> .left-header .el-menu-item.is-active {
  border-right: 2px solid;
}
</style>
<style scoped lang="scss">
.order-container {
  background: #F1F1F1;

  .order-header {
    padding: 0px 18%;
    min-width: 76rem;
    background: #ffffff;
  }

  .left-header {
    padding: 10px 18%;
    min-width: 76rem;
    background: #F1F1F1;
  }
}
</style>